export default "__VITE_ASSET__9b44ff02__"